import React, { useContext } from 'react'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import ThreeOptions from '../ThreeOptions'
import StepCounter from '../StepCounter'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import gif9 from './assets/15_bar graph 2.gif'
import jpg9 from './assets/static/15_bar-graph-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q9() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()

    return (
        <>
            <div className="picHold hid vis">
                <img className="gif9" src={settings.isAnimationPause ? jpg9 : gif9} />
            </div>
            <Headling text={translate('Cornering the Market')} />
            <Subtitle text={translate('What’s the value of securities I’ve bought and sold in the past year?')} />
            <ThreeOptions option1={translate('Up to NIS 10,000')}
                option2={translate('NIS 10,000-100,000')}
                option3={translate('Over NIS 100,000')}
                onOption1Press={() => {
                    setNewAnswer({ 9: 1 })
                    history.push('/Q/10')
                    ReactPixel.trackCustom('less_10', '');
                }}
                onOption2Press={() => {
                    setNewAnswer({ 9: 2 })
                    history.push('/Q/10')
                    ReactPixel.trackCustom('10_to_100', '');
                }}
                onOption3Press={() => {
                    setNewAnswer({ 9: 3 })
                    history.push('/Q/10')
                    ReactPixel.trackCustom('more_100', '');
                }}

            />
            <StepCounter />

        </>
    )
}



export default Q9

